import { getTxtIdMapperPath } from "../../router/txtIdMapper"
import { apiS, apiS_ignore1298 } from "./api-base"
import { getESGReqHeader } from "./tool-service"

//F2030101 畫面初始
export const getAudilogInitData = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2030101'),
        ReqBody: {}
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2030101")}`, method: 'post', data: ReqBody })
}

//auditLog Master
export const getAuditLogMList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('DPB0127'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("DPB0127")}`, method: 'post', data: ReqBody })
}
//auditLog Detail
export const getAuditLogDetail = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('DPB0128'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("DPB0128")}`, method: 'post', data: ReqBody })
}
//eventType E edit, V: view
export const updateAuditEyesEvent = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2030201'),
        ReqBody: reqBody
    }
    return await apiS_ignore1298({ url: `/${getTxtIdMapperPath("F2030201")}`, method: 'post', data: ReqBody })
}